import { Alert, Link } from "@platform/design-system";
import { Link as RouterLink } from "react-router";

import type { ReactNode } from "react";

export const NOT_FOUND_TEST_ID = "golden-not-found";

/** Any address the app has no page for. */
export const NotFoundPage = (): ReactNode => (
  <Alert
    data-testid={NOT_FOUND_TEST_ID}
    severity="warning"
    title="Page not found"
  >
    There is no page at this address.{" "}
    <Link component={RouterLink} to="/">
      Go to the cases
    </Link>
    .
  </Alert>
);
